// extracted by css-extract-rspack-plugin
export default {"modal":"Mf2f6YrVMDMB8Xbn__modal___","modalDescription":"q4LLcDJFEl2tjOkB__modalDescription___"};